export const dataHooks = {
    tickerUp: 'ticker-up-button',
    tickerDown: 'ticker-down-button',
};
//# sourceMappingURL=Ticker.constants.js.map